import { useContext, useState, useEffect } from "react";
import { Box, Typography, Container } from "@mui/material";
import ReBox from "../../../../common/ReBox";
import VideoPlayer from "../../../../common/VideoPlayer";
import CategoryButton from "../../components/CategoryButton";
import { GlobalContext, FunctionsContext } from "../../../../common/Context";
import LoadingModal from "../../../../common/LoadingModal";
import BackButton from "../../../../common/BackButton";
import { useTranslation } from "react-i18next";
import { TRYP_SVGS } from "../../../../../constants";
import { LEVEL_UP_CAT_VIDEO } from "../../../../../constants/ids";

const CategoryDisplay = ({ objState, watchList }) => {
  const { t } = useTranslation("LevelUp");
  const { optionState, setOptionState, desktopView, mobileView, tabletView } =
    useContext(GlobalContext);
  const { getAllVideos } = useContext(FunctionsContext);
  const { selSubCat, recoVidSel } = optionState;

  const allVideos = getAllVideos();

  const pageStyle = {
    width: "100%",
  };
  const headerAreaStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    mb: mobileView || tabletView ? "2rem" : "0",
  };
  const headerBox = {
    display: "flex",
    alignItems: mobileView ? "flex-start" : "center",
  };
  const logoBox = {
    display: "flex",
    width: "auto",
    height: mobileView ? "60%" : tabletView ? "80%" : "100%",
    mr: "1rem",
    fill: objState.logoColor,
    "& svg": {
      width: mobileView ? "5rem" : "6rem",
      height: mobileView ? "5rem" : "6rem",
    },
  };
  const headerTextStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    width: mobileView ? "100%" : "60%",
    ml: desktopView ? "2rem" : "1rem",
  };
  const titleStyle = {
    fontSize: desktopView ? "2.25rem" : "2rem",
    textTransform: mobileView ? "uppercase" : "capitalize",
  };
  const notTabletDescStyle = {
    mt: "0.5rem",
    lineHeight: "1.3rem",
  };
  const tabletDescStyle = {
    width: "85%",
    mt: "1rem",
    lineHeight: "1.3rem",
  };
  const lineBox = {
    width: "100%",
    height: "2px",
    backgroundColor: "#EAEAEA",
    m: mobileView ? "0 0 2rem 0" : "1rem 0",
  };
  const btnArea = {
    display: "flex",
    width: "100%",
  };
  const subCatTitleStyle = {
    mb: "0.5rem",
    textTransform: "capitalize",
  };
  const descStyle = {
    mb: "2rem",
    lineHeight: mobileView && "1.3rem",
  };
  const mobileVidBox = {
    display: "flex",
    justifyContent: "space-between",
    flexFlow: "row wrap",
  };
  const vidBox = {
    display: "flex",
    justifyContent: "flex-start",

    "&::after": {
      content: "''",
      flex: "auto",
    },
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  };
  const errorAreaStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: window.innerHeight,
  };
  const errorBoxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30%",
    height: "5rem",
  };

  const [isLoading, setIsLoading] = useState(true);
  const [categoryVids, setCategoryVids] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [currSubCategory, setCurrSubCategory] = useState(
    selSubCat
      ? selSubCat
      : objState.subCat.length
      ? objState.subCat[0].name
      : null,
  );
  const [isDisplay, setIsDisplay] = useState(true);
  const [isVideoLoad, setIsVideoLoad] = useState(0);

  useState(() => {
    selSubCat && setCurrSubCategory(selSubCat);
  }, [selSubCat]);

  useEffect(() => {
    if (allVideos.error) {
      setIsDisplay(false);
      console.error(allVideos.error);
      return;
    }
    if (allVideos.isLoading) {
      setIsLoading(true);
      return;
    }

    const filteredVids = allVideos.data.filter(
      (video) =>
        video.subCategory.toLowerCase() === currSubCategory.toLowerCase(),
    );
    setCategoryVids(filteredVids);
    setIsLoading(false);
  }, [allVideos, currSubCategory, objState]);

  const handleClick = () => {
    setOptionState({ nav: "levelUp", page: "main" });
  };

  return (
    <Container>
      {isDisplay ? (
        <Box sx={pageStyle}>
          {isLoading && <LoadingModal width={4} />}
          <Box sx={headerAreaStyle}>
            <BackButton text={t("backToCategories")} goBack={handleClick} />
            <Box sx={headerBox}>
              <Box
                sx={{
                  ...logoBox,
                  "& svg *": {
                    fill: objState.logoColor,
                  },
                }}>
                {TRYP_SVGS[objState.img]}
              </Box>
              <Box sx={headerTextStyle}>
                <Typography
                  variant="h1"
                  color={objState.logoColor}
                  sx={titleStyle}>
                  {objState.name}
                </Typography>
                {!tabletView && (
                  <Typography variant="body2" sx={notTabletDescStyle}>
                    {objState.desc}
                  </Typography>
                )}
              </Box>
            </Box>
            {tabletView && (
              <Typography variant="body2" sx={tabletDescStyle}>
                {objState.desc}
              </Typography>
            )}
            {desktopView && <Box sx={lineBox} />}
          </Box>
          <Box sx={btnArea}>
            {objState.subCat.map((subCategory, i) => (
              <CategoryButton
                subCategory={subCategory}
                currSubCategory={currSubCategory}
                setCurrSubCategory={setCurrSubCategory}
                isReady={isReady}
                categoryVids={categoryVids}
                setIsReady={setIsReady}
                setIsVideoLoad={setIsVideoLoad}
                isVideoLoad={isVideoLoad}
                key={i}
              />
            ))}
          </Box>
          {mobileView && <Box sx={lineBox} />}
          <Typography
            variant="h2"
            color={objState.logoColor}
            sx={subCatTitleStyle}>
            {currSubCategory}
          </Typography>
          {objState.subCat.map(
            (subCategory) =>
              subCategory.name.toLowerCase() ===
                currSubCategory.toLowerCase() && (
                <Typography
                  key={subCategory.name}
                  sx={descStyle}
                  variant="body2">
                  {subCategory.desc}
                </Typography>
              ),
          )}
          <Box
            sx={mobileView ? mobileVidBox : vidBox}
            id={LEVEL_UP_CAT_VIDEO(objState.name)}>
            {categoryVids?.map((video) => (
              <VideoPlayer
                video={video}
                widthPercent={mobileView ? 45 : tabletView ? 33.3 : 15}
                watchList={watchList}
                currSubCategory={currSubCategory}
                objState={objState}
                recoVidSel={recoVidSel}
                setIsVideoLoad={setIsVideoLoad}
                key={video.id}
              />
            ))}
          </Box>
        </Box>
      ) : (
        <Box sx={errorAreaStyle}>
          <ReBox sx={errorBoxStyle}>
            <Typography variant="h3" color="primary">
              {t("videoError")}
            </Typography>
          </ReBox>
        </Box>
      )}
    </Container>
  );
};

export default CategoryDisplay;
